<template>
    <Step :activeStep="1">
        <template v-slot:main>
            <div class="club-step__wine-picker" v-if="!getIsCustomSelection">
                <div class="club-step__wine-picker-list">
                    <div ref="scroll-incentive" class="club-step__scroll-incentive-wrapper">
                        <div class="club-step__scroll-incentive">
                            More wines below
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                        </svg>
                    </div>
                    <WineCatalog
                        v-for="catalog in availableCatalogs"
                        :key="`catalog-${catalog.ID}`"
                        :title="catalog.Title"
                        :description="catalog.Description"
                        :count="catalog.WineCount"
                        :sellingPrice="catalog.SellingPrice"
                        :originalPrice="catalog.OriginalPrice"
                        :actions="catalog.actions"
                        :wineList="catalog.WineItems"
                    />
                </div>
            </div>

            <div v-else class="club-step__custom-wine-picker custom-selections">
                <div class="club-step__wine-selection">
                    <div class="club-step__wine-selection__title">
                        Custom Selection
                    </div>
                    <div class="club-step__wine-selection__meta">
                        <div class="club-step__wine-selection__count">
                            {{ getShipmentWines.length }} bottles
                        </div>
                    </div>
                    <div class="club-step__wine-selection__list">
                        <WineCard
                            v-for="item in groupedShipmentWines"
                            :key="`wine-${item.ID}`"
                            :id="item.ID"
                            :wine="item.Wine"
                            :quantity="item.Quantity"
                            :removeMethod="() => { removeWineFromList(item) }"
                        />
                    </div>
                    <div class="club-step__wine-selection__description"></div>
                    <div class="club-step__wine-selection__actions">
                        <button
                            @click="setIsCustomSelection(false)"
                            class="btn-secondary"
                        >
                            Browse GV Collections
                        </button>
                        <button
                            @click="chooseCustomSelection"
                            class="btn-primary"
                        >
                            Choose selection
                        </button>
                    </div>
                </div>

                <div
                    v-for="(category, index) in getSelections"
                    :key="'category' + index"
                >
                    <b-row>
                        <b-col
                            ><h3>{{ category.Title }}</h3></b-col
                        >
                    </b-row>
                    <b-row class="product-list">
                        <b-col
                            class="product"
                            xl="2"
                            lg="3"
                            md="4"
                            sm="6"
                            xs="12"
                            v-for="(item, index) in category.Wines"
                            :key="'wine' + index"
                            :style="staggerProducts(index)"
                        >
                            <p
                                class="multiplier"
                                v-if="numSelectedWine(item) > 0"
                            >
                                x{{ numSelectedWine(item) }}
                            </p>
                            <img
                                v-if="
                                    item.Image &&
                                    item.Image.ID &&
                                    item.Image.URL
                                "
                                :src="item.Image.URL"
                            />
                            <div v-else class="placeholder"></div>
                            <div class="description">
                                <p class="name">{{ item.Title }}</p>
                                <p class="price">
                                    {{ getCurrency }} ${{
                                        item.LocalisedPrice.toFixed(2)
                                    }}
                                </p>
                            </div>
                            <div class="actions">
                                <button
                                    class="btn btn-light-outline shadow-light"
                                    v-if="numSelectedWine(item) === 0"
                                    @click="addShipmentWine(item)"
                                >
                                    Add to case
                                </button>
                                <div class="quantity" v-else>
                                    <button @click="removeShipmentWine(item)">
                                        <i class="fal fa-minus"></i>
                                    </button>
                                    <span>{{ numSelectedWine(item) }}</span>
                                    <button @click="addShipmentWine(item)">
                                        <i class="fal fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </template>
    </Step>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Step from "./layouts/Step.vue";
import WineCard from "./components/WineCard.vue";
import WineCatalog from "./components/WineCatalog.vue";
export default {
    name: "Step2",
    components: {
        Step,
        WineCard,
        WineCatalog,
    },
    mounted() {
        // console.log(this.getShipmentWines);
        this.handleScrollIncentive()
    },
    computed: {
        ...mapGetters([
            "getAvailableShipments",
            "getActiveCatalog",
            "getCatalogs",
            "getMemberID",
            "getMemberTier",
            "getShipmentCountry",
            "getShipments",
            "getIsCustomSelection",
            "getSelections",
            "getShipmentWines",
            "getCurrency",
        ]),
        groupedShipmentWines() {
            const w = this.getUniqueWinesWithQuantity(this.getShipmentWines);
            // console.log(w);
            return w;
        },
        availableCatalogs() {
            const memberTier = this.getMemberTier;
            let catalogs = this.getCatalogs;

            if (!memberTier) return [];

            return catalogs
                .filter(
                    (item) =>
                        item.MemberTier.ID === 0 ||
                        item.MemberTier.AnnuallyBottles ===
                            memberTier.AnnuallyBottles,
                )
                .map((cat) => {

                    cat.actions = []

                    if (cat.Wines.length < 1) {
                        cat = this.updateCustomCatalog(cat);
                    }

                    cat.actions.push(
                        {
                            title: "Choose selection",
                            method: () => {
                                this.chooseSelection(cat);
                            },
                            className: "btn-primary",
                        },
                    );

                    return cat;
                });
        },
    },
    methods: {
        ...mapActions([
            "addShipmentWine",
            "removeShipmentWine",
            "useCatalogWine",
            "setConfigStep",
            "changePreference",
            "setIsCustomSelection",
            "removeActiveCatalog",
            "getMemberData",
        ]),
        handleScrollIncentive() {
            const el = this.$refs['scroll-incentive']
            // console.log(el)
            if (!el) return
            let scrollAmount = 0

            window.addEventListener('scroll', () => {
                if (scrollAmount < 30) {
                    scrollAmount += 1
                } else {
                    el.classList.add('club-step__scroll-incentive--hidden')
                }
            })
        },
        updateCustomCatalog(cat) {
            cat.ID = null // Set to null so we can use as a flag later
            cat.Title = "Custom selection";
            cat.SellingPrice = null
            cat.OriginalPrice = null
            cat.WineCount = this.getShipmentWines.length;
            cat.WineItems = this.groupedShipmentWines
            cat.actions.push(
                {
                    title: "Browse wines",
                    method: () => {
                        this.setIsCustomSelection(true);
                    },
                    className: "btn-secondary",
                },
            );
            return cat;
        },
        isActiveCatalog(catalog) {
            return this.getActiveCatalog === catalog;
        },
        updatePreferences() {
            const data = new FormData();
            data.append("MemberID", this.getMemberID);
            data.append("MemberTier", this.getMemberTier.ID);
            data.append(
                "Shipments",
                this.getAvailableShipments.map((s) => s.ID),
            );

            if (this.getActiveCatalog) {
                data.append("Catalog", this.getActiveCatalog.ID);
            } else {
                console.assert(this.getShipmentWines.length > 0)
                // console.log('**********************')
                // console.log(this.getShipmentWines)
                // console.log('**********************')
                data.append(
                    "Wines",
                    this.getShipmentWines
                        .filter((w) => w.ID !== undefined)
                        .map((w) => w.ID),
                );
            }

            this.changePreference(data);
        },
        getUniqueWinesWithQuantity(arr) {
            return Object.values(
                arr.reduce((acc, obj) => {
                    const { ID } = obj;

                    if (ID) {
                        // If the object with the same ID is already in the accumulator, increase the quantity
                        if (acc[ID]) {
                            acc[ID].Quantity += 1;
                        } else {
                            // Otherwise, add the object to the accumulator with Quantity initialized to 1
                            acc[ID] = { ID, Quantity: 1, Wine: obj };
                        }
                    }

                    return acc;
                }, {}),
            );
        },
        chooseSelection(catalog) {
            if (catalog.ID) {
                this.useCatalogWine(catalog);
            } else {
                this.removeActiveCatalog();
                this.setIsCustomSelection(false); // Turn off wine picker
            }
            // update prefrences
            this.updatePreferences();
            this.setConfigStep(2);
        },
        staggerProducts(index) {
            return { "--animation-order": index };
        },
        numSelectedWine(wine) {
            let shipment = this.getShipmentWines,
                find = shipment.filter((m) => m.ID === wine.ID);
            return find.length;
        },
        chooseCustomSelection() {
            this.setIsCustomSelection(false);
            this.removeActiveCatalog();
            this.updatePreferences();
            this.setConfigStep(2);
        },
        removeWineFromList(item) {
            this.removeShipmentWine(item.Wine);
        },
    },
};
</script>
